














































import _ from 'lodash';
import mixins from 'vue-typed-mixins';
import { editName } from '@/main/store/listEditTypes';
import { mapActionsDvm } from '@/main/pages';
import { store } from '@/modules/servis/zakazka/store/edit';

import { UserRole } from '@/main/components/constants';

import { Tabs, UzivatelskeNotifikace } from '../../components';
import { EditMixin } from '../../mixins/editMixin';
import EditLayout from '../../EditLayout.vue';
import VozidloSelect from '../../components/microcomponents/VozidloSelect.vue';
import ZakaznikSelect from '../../components/microcomponents/ZakaznikSelect.vue';
import MicroPracovnikSelect from '../../components/microcomponents/PracovnikSelect.vue';
import WorkflowButtons from '../../components/WorkflowButtons.vue';
import HlavniKarta from './HlavniKarta.vue';
import InterniKarta from './InterniKarta.vue';
import { NAME } from './constants';
import { MENU_CODE, TAB_NAMES, TABS, WORKFLOW_STATES } from '../../constants';

export default mixins(EditMixin).extend({
	name: editName(NAME),
	components: {
		MicroPracovnikSelect,
		VozidloSelect,
		EditLayout,
		HlavniKarta,
		ZakaznikSelect,
		Tabs,
		WorkflowButtons,
		InterniKarta,
		UzivatelskeNotifikace,
	},
	watch: {
		Saga2Prp(newVal) {
			if (newVal) {
				this.getPodily();
			}
		},
	},
	computed: {
		isUserServiceAdvisorOrCre(): boolean {
			return this.pracovnik.PracovnikOzn === (UserRole.SERVICE_ADVISER) || this.pracovnik.PracovnikOzn === (UserRole.CRE);
		},
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(MENU_CODE, TABS.Hlavni)) tabItems.push(TAB_NAMES.HLAVNI);
			if (this.hasTabAccess(MENU_CODE, TABS.AddvancePay)) tabItems.push(TAB_NAMES.ADVANCEPAY);
			if (this.hasTabAccess(MENU_CODE, TABS.Prac)) tabItems.push(TAB_NAMES.PRAC);
			if (this.hasTabAccess(MENU_CODE, TABS.CiziVykonySlevyKorekce)) tabItems.push(TAB_NAMES.CIZI_VYKONY_SLEVY_KOREKCE);
			if (this.hasTabAccess(MENU_CODE, TABS.Kalkulace)) tabItems.push(TAB_NAMES.KALKULACE);
			if (this.hasTabAccess(MENU_CODE, TABS.Zalohy)) tabItems.push(TAB_NAMES.ZALOHY);
			if (this.hasTabAccess(MENU_CODE, TABS.Vydejky)) tabItems.push(TAB_NAMES.VYDEJKY);
			if (this.hasTabAccess(MENU_CODE, TABS.History)) tabItems.push(TAB_NAMES.HISTORY);
			if (this.hasTabAccess(MENU_CODE, TABS.Poznamky)) tabItems.push(TAB_NAMES.POZNAMKY);
			if (this.hasTabAccess(MENU_CODE, TABS.Zarazeni)) tabItems.push(TAB_NAMES.ZARAZENI);
			if (this.hasTabAccess(MENU_CODE, TABS.ZakazkyRef)) tabItems.push(TAB_NAMES.ZAKAZKY_REF);
			if (this.hasTabAccess(MENU_CODE, TABS.Reference)) tabItems.push(TAB_NAMES.REFERENCE);
			if (this.hasTabAccess(MENU_CODE, TABS.GDPR)) tabItems.push(TAB_NAMES.GDPR);
			if (this.hasTabAccess(MENU_CODE, TABS.PlanSkutecnost)) tabItems.push(TAB_NAMES.PLAN_SKUTECNOST);
			if (this.hasTabAccess(MENU_CODE, TABS.Doklady)) tabItems.push(TAB_NAMES.DOKLAD);
			if (this.hasTabAccess(MENU_CODE, TABS.OSC)) tabItems.push(TAB_NAMES.ZAKAZKY_OSC);
			if (this.Saga2Prp && this.hasTabAccess(MENU_CODE, TABS.Saga2)) tabItems.push(TAB_NAMES.SAGA_2);
			if (this.Saga2Prp && this.hasTabAccess(MENU_CODE, TABS.Saga2Komunikace)) tabItems.push(TAB_NAMES.SAGA_2_KOMUNIKACE);

			return _.pick(TABS, tabItems);
		},
		changeToState(): string {
			if (this.toGarance) {
				return WORKFLOW_STATES.GARANCE;
			}
			if (this.toInterni) {
				return WORKFLOW_STATES.INTERNI;
			}
			return WORKFLOW_STATES.GARANCE;
		},
	},
	methods: {
		...mapActionsDvm(store.actions),
	},
});
